// Deep import, not the barrel - see the note in document.model.ts. The base class of an `extends`
// is read at class-definition time, and the "@slick-components" barrel is circular with @models.
import { ISlickEmailerModel, SlickEmailerModel } from "../../slick-components/slick-emailer/slick-emailer.model";
import { IEmailModel } from "../email/email.model";

export interface IEmailerModel extends ISlickEmailerModel {
    referenceUuid: string;
    isSent: boolean;
    locationId?: number;
    lathamOrderId?: number;
    invoiceId?: number;
    jobId?: number;
    customerId?: number;
    purchaseOrderId?: number;
    paymentId?: number;
}
export class EmailerModel extends SlickEmailerModel implements IEmailerModel {
    referenceUuid: string;
    isSent: boolean;
    locationId?: number;
    lathamOrderId?: number;
    invoiceId?: number;
    jobId?: number;
    customerId?: number;
    purchaseOrderId?: number;
    paymentId?: number;
}